import React, {Fragment, useState, useEffect } from "react";
import { Card, Table, Button, Row, Col, Form, Modal } from "react-bootstrap";
import { formato_monto, isValidParam } from '../../common/Formatos'
import { ESTADO_CUOTA_RENDIDA, ESTADO_CUOTA_VISADA, ESTADO_CUOTA_RENDIDA_PARCIAL, ESTADO_CUOTA_VISADA_PARCIAL } from '../../common/constants'
import { serviceGetDocumento, serviceGetHistorialCuota } from '../../api/api-visar-rendicion-recupero.js';
import { LoadingComponent } from 'recupero-comunes';
import { useSelector } from 'react-redux'

const RendicionesHistoricas = ({cfg_form, declaracionPago}) => {

    const [loading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState(true);
    const [cuotasVisadas, setCuotasVisadas] = useState([]);
    const [idFolioCargaReciboPago, setFolioCargaReciboPago] = useState(null);

    const data_visar = useSelector((state) => state.visarRendicionRecuperoReducer)
    const {llaves} = data_visar

    useEffect(() => {
        if (declaracionPago && declaracionPago['cuotas']) {
            let cuotasVisadas = declaracionPago['cuotas'].filter(c =>
                [ESTADO_CUOTA_RENDIDA, ESTADO_CUOTA_VISADA, ESTADO_CUOTA_RENDIDA_PARCIAL, ESTADO_CUOTA_VISADA_PARCIAL].includes(c.codEstadoCuota)
            );
            setCuotasVisadas(cuotasVisadas);

            setFolioCargaReciboPago(declaracionPago['idFolioCargaReciboPago']);
        }
    }, [declaracionPago]);

    const verDocumento = async (folioDocumento) => {

        try {        
            if (folioDocumento) {
                setLoading(true); 
                let parametros = JSON.stringify({
                    idCaso: llaves && llaves['idCaso'],
                    idImplicadoCaso: llaves && llaves['idImplicado'],
                    idCompania: llaves && llaves['idOrgCaso'],
                    idfolioCarga: folioDocumento
                });
                console.log("en handleDocumento...", parametros);
                let query = Buffer.from(parametros).toString('base64')

                const response = await serviceGetDocumento(query);
                setLoading(false);

                var link = document.createElement("a");
                link.download = response.filename;
                link.href = "data:" + response.mimetype + ";base64," + response.file;
                link.click();
            }
        } catch (error) {
            console.log("error:", error);
            setLoading(false);
        }
    }
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [historialCuota, setHistorialCuota] = useState([]);
    const [loadingModal, setLoadingModal] = useState(false);

    const handleOpenModal = async (row) => {
        setSelectedRow(row);
        setShowModal(true);
        setHistorialCuota([]);
        setLoadingModal(true);
        try {
            const query = Buffer.from(JSON.stringify({
                idCaso: llaves && llaves['idCaso'],
                idImplicado: llaves && llaves['idImplicado'],
                nroCuota: row.nroCuota
            })).toString('base64');
            const result = await serviceGetHistorialCuota(query);
            setHistorialCuota(result || []);
        } catch (e) {
            console.error('Error al obtener historial cuota:', e);
        }
        setLoadingModal(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setHistorialCuota([]);
    };
  return (
    <Fragment>
    <LoadingComponent show={loading} />
    <div>
    <Card className="mb-3 p-3">
      <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }} onClick={() => setExpanded(!expanded)}>
          {expanded ? "▼" : "▶"} {(cfg_form && cfg_form["rinde-cuotas-rendhisto-subtitle"]) ? cfg_form["rinde-cuotas-rendhisto-subtitle"] : 'Rendiciones Históricas'}
      </Card.Header>
      {expanded && (
        <Card.Body>
            <Row>
                <Col>
                    <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {(cfg_form && cfg_form["rinde-cuotas-rendhisto-lbl-montopagopie"]) ? cfg_form["rinde-cuotas-rendhisto-lbl-montopagopie"] : 'Monto Pago (pie)'}
                    </Form.Label>
                    <br />
                    <Form.Text className='mb-3'>
                        {declaracionPago && isValidParam(declaracionPago['montoPagoPie']) ? formato_monto(declaracionPago['montoPagoPie']) : null}
                    </Form.Text>
                </Col>
                <Col>
                    <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {(cfg_form && cfg_form["rinde-cuotas-rendhisto-lbl-fechrend"]) ? cfg_form["rinde-cuotas-rendhisto-lbl-fecrend"] : 'Fecha Rendición'}
                    </Form.Label>
                    <br />
                    <Form.Text className='mb-3'>
                        {declaracionPago ? declaracionPago['fechaRendicionFormat'] : null}
                    </Form.Text>
                </Col>
                <Col>
                    <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {(cfg_form && cfg_form["rinde-cuotas-rendhisto-lbl-medpago"]) ? cfg_form["rinde-cuotas-rendhisto-lbl-medpago"] : 'Medio de Pago'}
                    </Form.Label>
                    <br />
                    <Form.Text className='mb-3'>
                        {declaracionPago ? declaracionPago['medioPagoPie'] : null}
                    </Form.Text>
                </Col>
                <Col>
                    <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {(cfg_form && cfg_form["rinde-cuotas-rendhisto-lbl-banco"]) ? cfg_form["rinde-cuotas-rendhisto-lbl-banco"] : 'Banco/Institución'}
                    </Form.Label>
                    <br />
                    <Form.Text className='mb-3'>
                        {declaracionPago ? declaracionPago['banco'] : null}
                    </Form.Text>
                </Col>
                <Col>
                    <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {(cfg_form && cfg_form["rinde-cuotas-rendhisto-lbl-cheque"]) ? cfg_form["rinde-cuotas-rendhisto-lbl-cheque"] : 'Cheque/Transacción'}
                    </Form.Label>
                    <br />
                    <Form.Text className='mb-3'>
                        {declaracionPago ? declaracionPago['nroChequeTrans'] : null}
                    </Form.Text>
                </Col>
                <Col md={2}>
                    <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {(cfg_form && cfg_form["rinde-cuotas-rendhisto-lbl-estado"]) ? cfg_form["rinde-cuotas-rendhisto-lbl-estado"] : 'Estado'}
                    </Form.Label>
                    <br />
                    <Form.Text className='mb-3'>
                        {(declaracionPago && declaracionPago['estado']) ? declaracionPago['estado'] : 'Visada'}
                    </Form.Text>
                    <a 
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            if (!idFolioCargaReciboPago) {                                
                                return;
                            }
                            verDocumento(idFolioCargaReciboPago); 
                        }}  
                        style={{ display: 'flex', alignItems: 'center', marginTop: '10px', 
                            color: !idFolioCargaReciboPago ? 'gray' : 'red',
                            pointerEvents: !idFolioCargaReciboPago ? 'none' : 'auto',
                            opacity: !idFolioCargaReciboPago ? 0.5 : 1
                        }}
                        >
                        {/* SVG como ícono */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 20 20">
                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                            <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
                        </svg>
                    </a>
                </Col>
            </Row>
            <br />
            <Table striped bordered hover>
            <thead>
                <tr>
                    <th>{(cfg_form && cfg_form["rinde-cuotas-rendhisto-grilla-nrocuota"]) ? cfg_form["rinde-cuotas-rendhisto-grilla-nrocuota"] : 'Nro. Cuota'}</th>
                    <th>{(cfg_form && cfg_form["rinde-cuotas-rendhisto-grilla-fechacuota"]) ? cfg_form["rinde-cuotas-rendhisto-grilla-nrocuota"] : 'Fecha Cuota'}</th>
                    <th>{(cfg_form && cfg_form["rinde-cuotas-rendhisto-grilla-montocuota"]) ? cfg_form["rinde-cuotas-rendhisto-grilla-montocuota"] : 'Monto Cuota'}</th>
                    <th>{(cfg_form && cfg_form["rinde-cuotas-rendhisto-grilla-estado"]) ? cfg_form["rinde-cuotas-rendhisto-grilla-estado"] : 'Estado'}</th>
                    <th>{(cfg_form && cfg_form["rinde-cuotas-rendhisto-grilla-montorendido"]) ? cfg_form["rinde-cuotas-rendhisto-grilla-montorendido"] : 'Monto Rendido'}</th>
                    <th>{(cfg_form && cfg_form["rinde-cuotas-rendhisto-grilla-totalpagado"]) ? cfg_form["rinde-cuotas-rendhisto-grilla-totalpagado"] : 'Total Pagado'}</th>
                    <th>{(cfg_form && cfg_form["rinde-cuotas-rendhisto-grilla-saldopendiente"]) ? cfg_form["rinde-cuotas-rendhisto-grilla-saldopendiente"] : 'Saldo Pendiente'}</th>
                    <th>{(cfg_form && cfg_form["rinde-cuotas-rendhisto-grilla-nrorendicion"]) ? cfg_form["rinde-cuotas-rendhisto-grilla-nrorendicion"] : 'N° Rendición'}</th>
                    <th>{(cfg_form && cfg_form["rinde-cuotas-rendhisto-grilla-fechrendicion"]) ? cfg_form["rinde-cuotas-rendhisto-grilla-fechrendicion"] : 'Fecha Rendición'}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {cuotasVisadas?.map((r, index) => (
                <tr key={index}>
                    <td>{r.nroCuota}</td>
                    <td>{r.fechaVencimientoFmt}</td>
                    <td>{formato_monto(parseFloat(r.montoCuota))}</td>
                    <td
                        style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => handleOpenModal(r)}
                    >{r.estadoCuota}</td>
                    <td>{formato_monto(parseFloat(r.montoRendidoTotal || 0))}</td>
                    <td>{formato_monto(parseFloat(r.montoTotalPagado || 0))}</td>
                    <td>{formato_monto(parseFloat(r.montoCuota) - parseFloat(r.montoRendidoTotal || 0))}</td>
                    <td>{r.idRendicionPago}</td>
                    <td>{r.fechaRendicionFmt}</td>                    
                    <td>
                        <a 
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                if (!r.idFolioCargaReciboPago) {                                    
                                    return;
                                }
                                verDocumento(r.idFolioCargaReciboPago); 
                            }}  
                            style={{ display: 'flex', alignItems: 'center', marginTop: '10px', 
                                color: !r.idFolioCargaReciboPago ? 'gray' : 'red',
                                pointerEvents: !r.idFolioCargaReciboPago ? 'none' : 'auto',
                                opacity: !r.idFolioCargaReciboPago ? 0.5 : 1
                            }}
                            >
                            {/* SVG como ícono */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 20 20">
                                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                                <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
                            </svg>
                        </a>
                    </td>
                </tr>
                ))}
                <tr>
                    <td></td>
                    <td className="text-end fw-bold">Total Cuotas:</td>
                    <td className="fw-bold">{formato_monto((declaracionPago && declaracionPago.totalCuotas) ? declaracionPago.totalCuotas : 0)}</td>
                    <td className="text-end fw-bold">Total Pagado:</td>
                    <td className="fw-bold">{formato_monto((declaracionPago && declaracionPago.totalPagoCuotas) ? declaracionPago.totalPagoCuotas : 0)}</td>
                    <td className="text-end fw-bold">Pendiente Pago:</td>
                    <td className="fw-bold">{formato_monto((declaracionPago && declaracionPago.saldoCuotas) ? declaracionPago.saldoCuotas : 0)}</td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
            </Table>
        </Card.Body>
      )}
    </Card>
    <Modal show={showModal} onHide={handleCloseModal} centered size="xl">
        <Modal.Header closeButton>
            <Modal.Title>Historial Pagos — Cuota {selectedRow?.nroCuota}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {loadingModal ? (
                <p>Cargando...</p>
            ) : (
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th style={{ whiteSpace: 'nowrap' }}>Fecha Pago</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Mto.Pagado</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Medio de Pago</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Banco/Institución</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Cheque/Transacción</th>
                            <th style={{ whiteSpace: 'nowrap' }}>Fecha Transacción</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {historialCuota.length === 0 ? (
                            <tr><td colSpan="7" className="text-center">Sin registros</td></tr>
                        ) : historialCuota.map((h, i) => (
                            <tr key={i}>
                                <td>{h.fechaPagoCuotaFmt}</td>
                                <td>{formato_monto(parseFloat(h.montoPagado))}</td>
                                <td>{h.medioPago}</td>
                                <td>{h.banco}</td>
                                <td>{h.nroChequeTrans}</td>
                                <td>{h.fechaTransaccionFmt}</td>
                                <td>
                                    <a
                                        href="#"
                                        onClick={(e) => { e.preventDefault(); if (!h.idFolioCargaReciboPago) return; verDocumento(h.idFolioCargaReciboPago); }}
                                        style={{ color: !h.idFolioCargaReciboPago ? 'gray' : 'red', pointerEvents: !h.idFolioCargaReciboPago ? 'none' : 'auto', opacity: !h.idFolioCargaReciboPago ? 0.5 : 1 }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 20 20">
                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                                            <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
                                        </svg>
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>Cerrar</Button>
        </Modal.Footer>
    </Modal>
    </div>
    </Fragment>
  );
};
export default RendicionesHistoricas;